import { createContext, useState, useEffect } from "react";
import apiRequest from "../lib/apiRequest.js";

export const AuthContext = createContext();

export const AuthContextProvider = ({ children }) => {

  //this is to test uploads

  // ✅ Initialize directly from localStorage (no refresh flicker)
  const [currentUser, setCurrentUser] = useState(() => {
    if (typeof window !== "undefined") {
      const user = localStorage.getItem("user");
      return user ? JSON.parse(user) : null;
    }
    return null; // default for SSR
  });


  // ✅ Check token on initial load

const [loading, setLoading] = useState(true);

useEffect(() => {
  // console.log("verifying ..")
  const verifyUser = async () => {
    try {
      const res = await apiRequest.get("/auth/authoriseme");
      // console.log("Response received verfication authcontext: ",res.data)
        if (res?.data?.id) {

          // console.log("fetched id from database")
          // Token/session is valid, so keep the full user from localStorage
          const user = localStorage.getItem("user");
          if (user) {

            // console.log("Localstorage: setting up currentuser with localstorage")
            setCurrentUser(JSON.parse(user)); // full user with image and other info
          } else {
            // no user in localstorate
            // console.log("localstorage: no user : removing user from current user and localstorage")
            setCurrentUser(null);
            localStorage.removeItem("user");
          }

      } else {
        // console.log("on fetching it gave error")        
        setCurrentUser(null);
        localStorage.removeItem("user");
      }
    } catch (err) {
      console.warn("🔒 Token check failed:", err?.response?.data || err.message);
      setCurrentUser(null);
      localStorage.removeItem("user");
    } finally {
      setLoading(false); // ✅ done checking
    }
  };

  verifyUser();
}, []);
  // ✅ Sync localStorage with state
  useEffect(() => {
    if (currentUser) {
      localStorage.setItem("user", JSON.stringify(currentUser));
    }
  }, [currentUser]);

  const updateUser = (data) => setCurrentUser(data);

  const login = async (credentials) => {
    try {
      const res = await apiRequest.post("/auth/login", credentials);
      if (res?.data) {
        updateUser(res.data);
      } else {
        throw new Error("Invalid login response");
      }
    } catch (error) {
      throw error;
    }
  };

  const SocialLogin = async (user) => {
    try {
      const res = await apiRequest.post("/auth/loginsocial", user);
      console.log("social user login response in authcontext: ",res.data)

      if (res?.data) {
        updateUser(res.data);
      } else {
        throw new Error("Invalid social login response");
      }
    } catch (error) {
      console.log(error);
    }
  };

  const logout = () => {
    setCurrentUser(null);
    localStorage.removeItem("user");
  };


return (
  <AuthContext.Provider value={{ currentUser, updateUser, login, logout, SocialLogin }}>
    {loading ? (
      <div></div> // Or a spinner / splash screen here
    ) : (
      children
    )}
  </AuthContext.Provider>
);


};
